import { FilterIdsValues } from 'shared/mui/Filter/hooks/useIdFilters';
import { OrderList } from 'types/embedded/order';
import { getId } from 'utils/getId';

export const getNotFoundIds = (orders: OrderList[], appliedIdFilters: FilterIdsValues) => {
  const notFoundIds = appliedIdFilters.id?.filter(
    (id) => id && !orders.some((order) => getId(order?.['@id']) === id),
  );
  const notFoundMerchantReferenceIds = appliedIdFilters.merchantReference?.filter(
    (id) => !orders.some((order) => order.merchantReference === id),
  );
  const notFoundProviderReferenceIds = appliedIdFilters.providerReferenceId?.filter(
    (id) => !orders.some((order) => order.providerReference === id),
  );
  const notFoundAnyIds = appliedIdFilters.anyId?.filter(
    (id) =>
      id &&
      !orders.some(
        (order) =>
          getId(order?.['@id']) === id ||
          order.providerReference === id ||
          order.merchantReference === id,
      ),
  );

  return {
    notFoundIds,
    notFoundMerchantReferenceIds,
    notFoundProviderReferenceIds,
    notFoundAnyIds,
  };
};
